import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .TasksPlanItem {
    width: 100%;
    display: flex;
    align-items: center;
    background: #ffffff;
    padding: 10px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);
    border-radius: 3px;
    margin-bottom: rem(2px);

    &__top {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-bottom: rem(5px);
    }

    &__icon {
      padding: 5px 20px 5px 5px;
    }

    &__date {
      font-weight: 100;
      white-space: break-spaces;
    }

    &__time {
      margin-right: rem(5px);
    }

    &__text {
      height: 20px;
      text-overflow: ellipsis;
      overflow: hidden;
      text-align: left;
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css`
    .TasksPlanItem {
      &__subject {
        color: ${colors.secondary.hex};
        font-weight: 500;
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
